/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreProjectSubtaskCommentCreateDto } from '../../models/core-project-subtask-comment-create-dto';
import { CoreProjectSubtaskCommentResponseDto } from '../../models/core-project-subtask-comment-response-dto';

export interface ProjectSubtaskCommentsControllerCreate$Params {

/**
 * The tenant identifier.
 */
  tenant: string;
      body: CoreProjectSubtaskCommentCreateDto
}

export function projectSubtaskCommentsControllerCreate(http: HttpClient, rootUrl: string, params: ProjectSubtaskCommentsControllerCreate$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreProjectSubtaskCommentResponseDto>> {
  const rb = new CoreRequestBuilder(rootUrl, projectSubtaskCommentsControllerCreate.PATH, 'post');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<CoreProjectSubtaskCommentResponseDto>;
    })
  );
}

projectSubtaskCommentsControllerCreate.PATH = '/o2-core/project-subtask-comments/{tenant}';
